export default "__VITE_ASSET__B3K63ebh__"